import React, {useState } from "react";
import SiteStatus from "../siteStatus/SiteStatus";
import ReactApexChart from "react-apexcharts";
import Chart from "react-apexcharts";
import Tbale from "../Table/Tbale";
function Dashbord({ bar, BaseUrl }) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };

  const [series, setseries] = useState([
    {
      name: "series1",
      data: [31, 40, 28, 51, 42, 109, 100],
    },
    {
      name: "series2",
      data: [11, 32, 45, 32, 34, 52, 41],
    },
  ]);
  const [options, setoptions] = useState({
    chart: {
      height: 100,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00.000Z",
        "2018-09-19T01:30:00.000Z",
        "2018-09-19T02:30:00.000Z",
        "2018-09-19T03:30:00.000Z",
        "2018-09-19T04:30:00.000Z",
        "2018-09-19T05:30:00.000Z",
        "2018-09-19T06:30:00.000Z",
      ],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  });


  return (
    <>
      <div
        className={`${
          bar ? "md:block  col-span-10 mr-16" : "md:block  col-span-11 mr-10"
        }`}
      >
        <SiteStatus BaseUrl={BaseUrl} />
        <div className="overflow-hidden w-full  mt-10 flex justify-evenly align-middle">
          <div id="chart" className="w-1/4 bg-white p-2 rounded-md shadow-md ">
            <ReactApexChart
              options={options}
              series={series}
              type="area"
              height={250}
            />
          </div>
          <div id="chart" className="w-1/4 bg-white p-2 rounded-md shadow-md ">
            <ReactApexChart
              options={options}
              series={series}
              type="area"
              height={250}
            />
          </div>
          <div id="chart" className="w-1/4 bg-white p-2 rounded-md shadow-md ">
            <Chart options={options} series={series} type="bar" height={250} />
          </div>
        </div>
        <Tbale />
      </div>
    </>
  );
}

export default Dashbord;
